itsoftApp.createModule("testExtra", function () {
    const testBlockEl = document.querySelector('#test');

    if (!testBlockEl) {
        return;
    }
    
    const dots = testBlockEl.querySelector(".js-dots");
    const sliderNav = testBlockEl.querySelector(".js-slider-nav");

    let urlGlobal = null;
    let currentFirstQuestionValue = null;
    const mainColorEl = testBlockEl.querySelector('.js-main-color');
    const prevBtnEl = testBlockEl.querySelector(".js-prev-btn");
    const nextBtnEl = testBlockEl.querySelector(".js-next-btn");
    const testToggleEls = testBlockEl.querySelectorAll(".js-test-toggle");
    // const testInputEls = testBlockEl.querySelectorAll(".js-test-input");
    const testFormEl = testBlockEl.querySelector(".js-test-form");
    let sexMaleFlag = false;
    const sexEls = testBlockEl.querySelectorAll("[for='sex-male'], [for='sex-female']");
    const thirdStepEl = testBlockEl.querySelector(".js-step-3");
    const nineStepEl = testBlockEl.querySelector(".js-step-9");

    const testStepEls = testBlockEl.querySelectorAll(".js-step-block");
    const resultEl = testBlockEl.querySelector(".js-result");
    const conditionButtonEl = testBlockEl.querySelector(".js-condition");
    const submitButtonEl = testBlockEl.querySelector(".js-submit");
    const inputLabelEls = testBlockEl.querySelectorAll(".js-input-label");
    const sliderNavEl = testBlockEl.querySelector(".js-slider-nav");
    const testStartBtn = testBlockEl.querySelector(".js-start-btn");
    const note = testBlockEl.querySelector(".js-note");
    const sliderTarget = testBlockEl.querySelector(".js-slider-target");
    const triggerBlock = testBlockEl.querySelector(".js-trigger-block");

    const processResults = function (data) {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = data;
        const resultData = wrapper.querySelector(".js-result");
        sliderNavEl.classList.add('js-z-index-less');
        dots.classList.add("js-hide");
        sliderNav.classList.add("js-hide");
        Swiper.initedSliders["test"].appendSlide(resultData);
        Swiper.initedSliders["test"].slideTo(Swiper.initedSliders["test"].slides.length - 1);

        const testResetEl = testBlockEl.querySelector(".js-test-reset");
        testResetEl.addEventListener("click", resetTest);
    };

    const resetTest = function (evt) {
        evt.preventDefault();

        // currentFirstQuestionValue = null;
        sliderNavEl.classList.remove('js-z-index-less');

        conditionButtonEl.classList.remove("js-hide");
        submitButtonEl.classList.add("js-hide");

        const actualTestToggleEls = testBlockEl.querySelectorAll(".js-test-toggle");

        Array.prototype.forEach.call(actualTestToggleEls, function (input) {
            input.checked = false;
        });

        // Array.prototype.forEach.call(testInputEls, function (input) {
        //     input.value = "";
        // });

        dots.classList.remove("js-hide");
        sliderNav.classList.remove("js-hide");

        Swiper.initedSliders["test"].removeSlide(Swiper.initedSliders["test"].slides.length - 1);
        if (!testBlockEl.querySelector(".js-step-3") && sexMaleFlag) {
            sexMaleFlag = false;
            Swiper.initedSliders["test"].addSlide(2, thirdStepEl);
            Swiper.initedSliders["test"].addSlide(8, nineStepEl);
            Swiper.initedSliders["test"].params.custom.toggleSetEls = testBlockEl.querySelectorAll(".js-toggle-set");
        }
        Swiper.initedSliders["test"].slideTo(0);

        const checkedToggles = Array.prototype.filter.call(actualTestToggleEls, item => item.checked);
        Swiper.initedSliders["test"].customCheckedToggles = checkedToggles;
        Swiper.initedSliders["test"].params.custom.checkedToggles = checkedToggles;

        if (Swiper.initedSliders["test"].params.custom.checkedToggles.length != Swiper.initedSliders["test"].params.custom.toggleSetEls.length) {
            Swiper.initedSliders["test"].allowSlideNext = false;
            Swiper.initedSliders["test"].params.custom.nextBtn.disabled = true;
        } else {
            Swiper.initedSliders["test"].allowSlideNext = true;
            Swiper.initedSliders["test"].params.custom.nextBtn.disabled = false;
        }

        Swiper.initedSliders["test"].params.custom.requested = false;
    }

    const onErrorLoad = function (data) {
        console.log("error ", data);
    };

    const sendRequest = function (onSuccess, onError) {
        const xhr = new XMLHttpRequest();
        Swiper.initedSliders["test"].params.custom.createRequest = createRequest;

        xhr.addEventListener("load", function () {
            if (xhr.status === 200 && onSuccess) {
                onSuccess(xhr.response);
            } else {
                onError(xhr.response);
            }
        });

        xhr.addEventListener("error", function () {
            onError("Произошла ошибка соединения");
        });
        xhr.addEventListener("timeout", function () {
            onError("Запрос не успел выполниться за " + xhr.timeout + "мс");
        });

        xhr.timeout = 10000;

        xhr.open("GET", urlGlobal);
        xhr.send();
    }

    const preResultActions = function (resultValue) {  
        let url = "?";
        let value = resultValue;

        // Array.prototype.forEach.call(allInputsValues, function (inputValue, index, arr) {
        //     value += inputValue.value[0];
        // });

        url += 'result' + "=" + value;

        url.replace(/\s/g, '+');

        const action = testFormEl.getAttribute("action");

        const query = action + url;

        // history.pushState("", "", url);
        urlGlobal = query;
        sendRequest(processResults, onErrorLoad, true);
    }

    const debouncer = itsoftApp.utils.debouncer(preResultActions, 500);

    const calculateResult = function (allInputsValues) {
        let result = 0;
        Array.prototype.forEach.call(allInputsValues, function (toggle) {
            result += parseInt(toggle.point, 10);
        })

        return result;
    }

    const createRequest = function () {
        let allInputsValues = [];
        const actualTestStepEls = testBlockEl.querySelectorAll(".js-step-block");

        allInputsValues = Array.prototype.map.call(actualTestStepEls, function (stepBlock) {
            const allTestInputsEls = stepBlock.querySelectorAll(".js-test-toggle") || [];
            const allCheckedInputs = Array.prototype.filter.call(allTestInputsEls, item => item.checked) || [];
            
            return {
                name: stepBlock.getAttribute("name") || stepBlock.getAttribute("data-name") || allCheckedInputs[0].name,
                value: Array.prototype.map.call(allCheckedInputs, (checkedTestInput) => checkedTestInput.value),
                point: Array.prototype.map.call(allCheckedInputs, (checkedTestInput) => checkedTestInput.getAttribute("data-point")),
            }
        });
        
        let resultValue = calculateResult(allInputsValues);

        debouncer(resultValue);
    }

    // const onInputChange = function (evt) {
    //     const activeItem = testStepEls[Swiper.initedSliders["test"].activeIndex];
    //     const activeInput = activeItem.querySelector(".js-test-input");

    //     if (activeInput.value) {
    //         Swiper.initedSliders["test"].allowSlideNext = true;
    //         Swiper.initedSliders["test"].params.custom.nextBtn.disabled = false;
    //     } else {
    //         Swiper.initedSliders["test"].allowSlideNext = false;
    //         Swiper.initedSliders["test"].params.custom.nextBtn.disabled = true;
    //     }

    //     if (Swiper.initedSliders["test"].params.custom.checkedToggles.length == Swiper.initedSliders["test"].params.custom.toggleSetEls.length && Swiper.initedSliders["test"].activeIndex + 1 == Swiper.initedSliders["test"].slides.length && ((activeInput && activeInput.value) || !activeInput)) {
    //         conditionButtonEl.classList.add("js-hide");
    //         submitButtonEl.classList.remove("js-hide");
    //     } else {
    //         conditionButtonEl.classList.remove("js-hide");
    //         submitButtonEl.classList.add("js-hide");
    //     }
    // }

    const onLabelClickRecordChoice = function (evt) {
        const target = evt.currentTarget;
        currentFirstQuestionValue = target.control.value;

        if (currentFirstQuestionValue == 'sex-male' && !sexMaleFlag) {
            sexMaleFlag = true;
            Swiper.initedSliders["test"].removeSlide([2, 8]);
            Swiper.initedSliders["test"].params.custom.toggleSetEls = testBlockEl.querySelectorAll(".js-toggle-set");
        } else if (currentFirstQuestionValue == 'sex-female' && sexMaleFlag) {
            sexMaleFlag = false;
            Swiper.initedSliders["test"].addSlide(2, thirdStepEl);
            Swiper.initedSliders["test"].addSlide(8, nineStepEl);
            Swiper.initedSliders["test"].params.custom.toggleSetEls = testBlockEl.querySelectorAll(".js-toggle-set");
        }
    }

    const onToggleChange = function (evt) {
        let checkedToggles = [];
        const actualTestToggleEls = testBlockEl.querySelectorAll(".js-test-toggle");

        checkedToggles = Array.prototype.filter.call(actualTestToggleEls, item => item.checked);
        Swiper.initedSliders["test"].customCheckedToggles = checkedToggles;
        Swiper.initedSliders["test"].params.custom.checkedToggles = checkedToggles;

        if (Swiper.initedSliders["test"].params.custom.checkedToggles.length < Swiper.initedSliders["test"].activeIndex + 1 && Swiper.initedSliders["test"].params.custom.checkedToggles.length != Swiper.initedSliders["test"].slides.length) {
            Swiper.initedSliders["test"].allowSlideNext = false;
            Swiper.initedSliders["test"].params.custom.nextBtn.disabled = true;
        } else {
            Swiper.initedSliders["test"].allowSlideNext = true;
            Swiper.initedSliders["test"].params.custom.nextBtn.disabled = false;
            Swiper.initedSliders["test"].slideNext();
        }

        if (Swiper.initedSliders["test"].params.custom.checkedToggles.length == Swiper.initedSliders["test"].params.custom.toggleSetEls.length && Swiper.initedSliders["test"].activeIndex + 1 == Swiper.initedSliders["test"].slides.length) {
            if (!Swiper.initedSliders["test"].params.custom.requested) {
                Swiper.initedSliders["test"].params.custom.requested = true;
                conditionButtonEl.classList.add("js-hide");
                submitButtonEl.classList.remove("js-hide");
                createRequest();
            }
        } else {
            conditionButtonEl.classList.remove("js-hide");
            submitButtonEl.classList.add("js-hide");
        }
    }

    const init = function () {
        Array.prototype.forEach.call(sexEls, function (sexEl) {
            sexEl.addEventListener("click", onLabelClickRecordChoice);
        });
        
        Array.prototype.forEach.call(testToggleEls, function (input) {
            input.addEventListener("change", onToggleChange);
        });

        // Array.prototype.forEach.call(testInputEls, function (input) {
        //     input.addEventListener("input", onInputChange);
        // })

        submitButtonEl.addEventListener("click", createRequest);
    }

    if (testStartBtn) {
        testStartBtn.addEventListener("click", function (evt) {
            evt.preventDefault();
            triggerBlock.classList.add("js-hide");
            sliderTarget.classList.add("js-active");
            note.classList.add("js-active");
        });
    }

    init();
});